import { TagModel } from '@core/models/tag.model';
import { getUserId } from '@core/utils/getUserId';
import * as moment from 'moment';

import { BaseModel } from './base.model';
import { InviteModel } from './invite.model';
import { UserModel } from './user.model';

export interface NotificationInterface {
  userId: string;
  count: number;
}

export class TaskModel extends BaseModel {
  id: string;
  name: string;
  body: any = {};
  projectId: string;
  responsible: InviteModel;
  responsibleId: string;
  status: any;
  statusId: string;
  authorId: string;
  deadlineAt: string;
  deadlineStatus: string;
  spentTime: number;
  countMessages: number;
  followers: string[] = [];
  notifications: NotificationInterface[] = [];
  followersUsers: UserModel[] = [];
  favorites: string[] = [];
  likes: any[] = [];
  tags: string[] = [];
  tagList: TagModel[] = [];
  checkList: any[] = [];
  createdAt: string;
  completedAt: string;
  archivedAt: string;
  updatedAt: string;
  afterId: string;
  beforeId: string;
  files: any[] = [];
  order: number;
  countNotifications: number;
  insertIndex: number;
  isComplete: boolean;
  isArchive: boolean;
  userIdArchive: string;
  userIdComplete: string;
  userArchive: InviteModel;
  userComplete: InviteModel;

  getDeadlineCssClass() {
    let deadlineClass = '';

    if (this.deadlineAt) {
      const nowStartDay = moment().startOf('day');
      const nowEndDay = moment().endOf('day');
      const deadlineAt = moment(this.deadlineAt).valueOf();

      if (deadlineAt >= nowStartDay.valueOf() && deadlineAt <= nowEndDay.valueOf()) {
        deadlineClass = 'deadline__color_soon';
      } else if (deadlineAt < nowStartDay.valueOf()) {
        deadlineClass = 'deadline__color_overdue';
      }
    }

    return deadlineClass;
  }

  get isFavorite() {
    const userId = getUserId();
    return this.favorites.indexOf(userId) > -1;
  }

  set isFavorite(value: boolean) {
    const userId = getUserId();
    const index = this.favorites.indexOf(userId);

    if (value && index === -1) {
      this.favorites = [...this.favorites, userId];
    } else if (!value && index > -1) {
      this.favorites = this.favorites.filter(id => id !== userId);
    }
  }
}
